import fieldOperationsRoutes from "./fieldos_routes";
import voiceRoutes from "./voice_routes";
import waccRoutes from "./wacc_routes";
import commos_routes from "./commos_routes";

const service = localStorage.getItem("laddar_service");

const routes = {
  field_os: fieldOperationsRoutes,
  voice: voiceRoutes,
  wacc: waccRoutes,
  comms: commos_routes,
};

export default routes[service] || fieldOperationsRoutes;